import PropTypes from 'prop-types';
import Constant from '@/common/constant/Constant';
import PromptIcon from '@/component/common/icons/PromptIcon';

export default function PromptButton({
    isLoading,
    filterKnowledgeListData,
    promptOpen,
    setPromptOpen
}) {

    const isDisplayPromptBtn = () => {
        const isHidden = isLoading ||
            filterKnowledgeListData?.projectIdKnowledgeSelected === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG;
        return !isHidden;
    }

    if (!isDisplayPromptBtn()) return null;

    return (
        <button
            className="btn-reset-default ai-chat-prompt-btn"
            onClick={() => setPromptOpen(!promptOpen)}
        >
            <PromptIcon width={18} height={18}/>
        </button>
    );
}

PromptButton.propTypes = {
    isLoading: PropTypes.bool,
    filterKnowledgeListData: PropTypes.object,
    promptOpen: PropTypes.bool,
    setPromptOpen: PropTypes.func
};
